<template>
    <!--
            作者：kmdshop
            时间：2019-10-25
            描述：会员-用户列表
        -->
    <div class="user">
      <!--搜索表单-->
      <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="用户">
            <el-input v-model="formInline.search" placeholder="用户ID或者手机号或者昵称"></el-input>
          </el-form-item>
          <el-form-item label="上级">
            <el-input v-model="formInline.agent_id" placeholder="用户ID"></el-input>
          </el-form-item>
          <el-form-item label="会员等级">
            <el-select v-model="formInline.grade_id" placeholder="请选择">
              <el-option label="全部" value="0"></el-option>
              <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="注册时间">
            <div class="block">
              <span class="demonstration"></span>
              <el-date-picker v-model="formInline.reg_date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>

      </div>

      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="user_id" label="ID" width="80">

            </el-table-column>
            <el-table-column prop="nickName" label="昵称" width="120">
              <template slot-scope="scope">
                <p>{{ scope.row.nickName }}</p>

              </template>
            </el-table-column>
            <el-table-column prop="mobile" label="手机号码" width="120">
              <template slot-scope="scope">

                <p>{{ scope.row.mobile }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="is_forbidden" label="状态" width="80">
              <template slot-scope="scope">
                <div v-if="scope.row.is_forbidden==0">
                  <p>启用</p>
                </div>
                <div v-if="scope.row.is_forbidden==1">
                  <p>禁用</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="avatarUrl" label="微信头像">
              <template slot-scope="scope">
                <div v-if="scope.row.avatarUrl">
                  <img :src="scope.row.avatarUrl" width="30px" height="30px"/>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="" label="会员等级">
              <template slot-scope="scope">
                <span v-if="scope.row.grade_id == 0">无等级</span>
                <span v-else>{{ scope.row.grade ? scope.row.grade.name : '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="points" label="积分"></el-table-column>
            <el-table-column prop="balance" label="余额"></el-table-column>
            <el-table-column prop="money" label="可提现佣金"></el-table-column>


            <el-table-column prop="" label="上级" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.referee_id == 0">无</span>
                <span v-else @click="viewUser(scope.row.referee_id)">{{ scope.row.referee_id>0 && scope.row.agent ? scope.row.agent.nickName : '' }}（ID: {{scope.row.referee_id}}）</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="粉丝">
              <template slot-scope="scope">
                <span @click="viewFirstUser(scope.row.user_id)">{{scope.row.first_num}} 人</span>
              </template>
            </el-table-column>

            <el-table-column prop="create_time" label="注册时间" width="140"></el-table-column>
            <!-- <el-table-column fixed="right" label="操作" width="160">
              <template slot-scope="scope">
                <el-button @click="detailClick(scope.row)" type="text" size="small" v-auth="'/myteam/myteam/detail'">详情</el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </div>

        <!--分页-->
        <div class="pagination">
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background :current-page="curPage"
          :page-sizes="[20, 100,500, 1000]"
          layout="total,sizes, prev, pager, next, jumper"
          :total="totalDataNumber"></el-pagination>
        </div>
      </div>


      <Detail v-if="open_edit" :open_edit="open_edit" :form="userModel"
       :gradeList="gradeList" @closeDialog="closeDialogFunc($event, 'edit')"></Detail>


    </div>
  </template>

  <script>
  import MyTeamApi from '@/api/myteam.js';
  import Detail from './dialog/Detail.vue';
  import store from '@/store/'
  import qs from 'qs';
  export default {
    components: {
      Detail,
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          search: '',
          grade_id: '',
          reg_date: '',
          agent_id: '',
        },
        /*是否打开添加弹窗*/
        open_add: false,
        open_add1: false,
        /*是否打开批量修改等级弹窗*/
        open_changegrade: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        open_relation: false,
        /*当前编辑的对象*/
        userModel: {
          // 会员到期时间设置
          expire_date_text: '',
        },
        /*等级*/
        gradeList: [],
        /*选中的*/
        multipleSelection: [],
        /*选择的会员列表*/
        select_list: [],
        app_id: 10001,
      };
    },
    created() {
      this.getBaseInfo()
      /*获取列表*/
      this.getTableList()
    },

    methods: {
      // 获取基础信息,获取app_id,跳转路由需要
      async getBaseInfo() {
        let res = await store.dispatch('common/getBaseInfo')
        this.app_id = res.app_id
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val
        this.getTableList()
      },
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1
        this.pageSize = val
        this.getTableList()
      },
      detailClick(item){
        this.userModel = item;
      this.open_edit = true;
      },
      /*获取列表*/
      getTableList() {
        let self = this
        self.loading = true
        let Params = self.formInline
        Params.page = self.curPage
        Params.list_rows = self.pageSize
        MyTeamApi.userlist(Params, true)
          .then(data => {
            self.loading = false
            self.tableData = data.data.list.data
            self.totalDataNumber = data.data.list.total
            self.gradeList = data.data.grade
          })
          .catch(error => {
            self.loading = false
          });
      },

      viewUser(user_id){
        this.curPage = 1;;
        this.pageSize = 20;
        this.tableData = [];
        this.formInline.search = user_id;
        this.formInline.agent_id = '';
        this.getTableList();
      },

      viewFirstUser(user_id){
        this.curPage = 1;;
        this.pageSize = 20;
        this.tableData = [];
        this.formInline.search = '';
        this.formInline.agent_id = user_id;
        this.getTableList();
      },

      /*搜索查询*/
      onSubmit() {
        let self = this
        self.curPage = 1
        self.getTableList()
      },
  /*关闭弹窗*/
  closeDialogFunc(e, f) {

      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }

    },



    }
  };
  </script>
  <style></style>



// WEBPACK FOOTER //
// src/views/myteam/index/index.vue